import React, { Component } from 'react';

import {Link} from 'react-router';
import {observer} from 'mobx-react';


class TestimonialsPage extends Component {
  render() {
    const testimonials = this.props.testimonials;
    return (
      <div className="grid_16">
        <h1>Testimonials</h1>
        {testimonials.map((testimonial, testimonialIndex) => (
          <div key={testimonialIndex}>
          <blockquote>
            {testimonial.content.split(`\n`).map((item, index) => <p key={index}>{item}</p>)}
          </blockquote>
          <br />
          <p className="author">{testimonial.author}</p>
          </div>
        ))}
        <br /><br />
        <h2>Other Companies &amp; Tradesmen We Work With</h2>
        <p>We work closely with and would recommend the following local tradesmen and companies:</p>
        <ul>
          <li>AG Scaffolding (York) 07951 229531</li>
          <li>Garry Marshall Scaffolding. 07832 170407.</li>
          <li>Osgoldcross Joinery - 079769577487</li>
          <li>Liam Turner Leadwork and Roofing 01904 793538.   07821 797630</li>
          <li>Burton Roofing Merchants 01904 781467</li>
          <li>Garry Kitson Builder - 07739405996, 01904784666</li>
        </ul>


        <br /><br />
        <div className="grid_16">
          <br /><br /><br />
          <div className="infobox">
            <Link to="/contact">Contact us for a free, no obligation estimate</Link>
            <p>Need an urgent roof repair? Or maybe just some friendly roofing advice? we're happy to help.</p>
            <br />
            <p className="big">
              <Link to="/contact">Send us an email</Link>
              {' '}
              or call: <span className="phone">07866 432026</span> (Mobile), <span className="phone">01904 793538</span> (Home)<br />
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default observer(['testimonials'])(TestimonialsPage);




/** WEBPACK FOOTER **
 ** ./src/TestimonialsPage.js
 **/